import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { homeTabs } from './home.constants';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent {
  public homeTabs = homeTabs;

  constructor(private platform: Platform) {
    this.platform.ready().then(() => {
      ScreenOrientation.addListener('screenOrientationChange', () => {
        ScreenOrientation.orientation().then((orientation) => {
          console.log('Orientation changed to:', orientation); // keeping for posterity...old functionality is deprecated
        });
      });
    });
  }
}
